import { render, staticRenderFns } from "./invoiceInfo.vue?vue&type=template&id=6553251a&scoped=true"
import script from "./invoiceInfo.vue?vue&type=script&lang=js"
export * from "./invoiceInfo.vue?vue&type=script&lang=js"
import style0 from "./invoiceInfo.vue?vue&type=style&index=0&id=6553251a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6553251a",
  null
  
)

export default component.exports